import { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import InputGroup from '../Forms/InputGroup';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getTranslationKey } from '../../modules/utils/helpers';
import type { Notify } from '../../typings/redux';

interface RedeemDiscountKeyFormValues {
  discountKey: string;
}

interface RedeemDiscountKeyOwnProps {
  notify: Notify;
  redeemDiscountKey: (
    values: RedeemDiscountKeyFormValues,
    notify: Notify,
    callback: () => void
  ) => void;
}

type RedeemDiscountKeyProps = RedeemDiscountKeyOwnProps &
  InjectedFormProps<RedeemDiscountKeyFormValues, RedeemDiscountKeyOwnProps>;

interface RedeemDiscountKeyState {
  isOpen: boolean;
}

class RedeemDiscountKey extends Component<RedeemDiscountKeyProps, RedeemDiscountKeyState> {
  constructor(props: RedeemDiscountKeyProps) {
    super(props);

    this.state = {
      isOpen: false
    };

    this.toggle = this.toggle.bind(this);
  }

  handleClose = () => this.setState({ isOpen: false });

  toggle() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  }

  render() {
    const { redeemDiscountKey, handleSubmit, notify } = this.props;

    return (
      <div>
        <p className="mb-0">
          <a
            href="/"
            className="mb-0"
            onClick={(e) => {
              e.preventDefault();
              this.toggle();
            }}
          >
            {getTranslationKey('pricingTables.haveDiscountKey')}
          </a>
        </p>
        <Modal
          centered
          isOpen={this.state.isOpen}
          toggle={this.toggle}
          wrapClassName="modal-primary"
          size="md"
        >
          <ModalHeader toggle={this.toggle}>
            {getTranslationKey('pricingTables.redeemDiscountKey')}
          </ModalHeader>
          <ModalBody>
            <form
              onSubmit={handleSubmit((values) =>
                redeemDiscountKey(values, notify, this.handleClose)
              )}
            >
              <Field
                className="m-b-0"
                component={InputGroup}
                name="discountKey"
                field={{
                  type: 'text',
                  placeholder: getTranslationKey('pricingTables.discountKey'),
                  title: getTranslationKey('pricingTables.discountKey')
                }}
              />
              <Button type="submit" color="primary" className="w-100-p">
                {getTranslationKey('pricingTables.redeemDiscountKey')}
              </Button>
            </form>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-danger pull-left"
              onClick={() => this.setState((prevState) => ({ isOpen: !prevState.isOpen }))}
            >
              {getTranslationKey('abort')}
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

interface RootState {
  notify: Notify;
}

function mapStateToProps({ notify }: RootState) {
  return { notify };
}

const RedeemDiscountKeyWithForm = reduxForm<RedeemDiscountKeyFormValues, RedeemDiscountKeyOwnProps>(
  {
    form: 'redeemDiscountKeyForm'
  }
)(RedeemDiscountKey);

export default connect(mapStateToProps, actions)(RedeemDiscountKeyWithForm);
